import styled from '@emotion/styled';
import { getColor } from 'UIUtils';

export const CameraContainer = styled.div`
  position: relative;
  height: 280px;
  background: ${getColor('white')};
  overflow: hidden;
`;

export const CameraContainerError = styled(CameraContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding-left: 30px;
  padding-right: 30px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 10;
  background: ${getColor('white')};
`;

export const ErrorTextContainer = styled.div`
  display: flex;
  gap: 8px;
  color: ${getColor('error-text-color')};
  align-items: center;
`;

export const Video = styled.video`
  display: none;
`;

export const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
  object-fit: cover;
  -webkit-border-radius: 1px;
`;

export const CameraActionsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 0 20px 20px 20px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
`;
